//技师管理
import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Modal, Button, DatePicker, Space, Table, message, Select, Image, Input } from 'antd';
import { UsergroupAddOutlined, AppstoreOutlined, SettingOutlined } from '@ant-design/icons';
import styles from './index.less'
import util from '../../util/util';
import Menus from '@/component/menu'
import Record from '@/component/record'
const { RangePicker } = DatePicker;
const { Option } = Select;
const Index = () => {
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [myValues, setmyValues] = useState({});
    const [tableLoading, setTableLoading] = useState(false);
    useEffect(() => {
        getData()
    }, [page, pageSize])
    const getData = (values) => {
        setTableLoading(true)
        util.httpRequest({
            url: util.API + `/admin/massageList`,
            method: 'POST',
            data: {
                pageNum: page,
                pageSize: pageSize,
                status: myValues.status || 1,
                searchContent: myValues.searchContent || '',
            }
        }).then((res) => {
            if (res.code === 200) {
                setDataSource(res.data.list)
                setTotal(res.data.total)
            } else {
                message.error(res.message)
            }
            setTableLoading(false)
        }).catch((err) => {

        });
    }
    const getSearchData = (values) => {
        setTableLoading(true)
        util.httpRequest({
            url: util.API + `/admin/massageList`,
            method: 'POST',
            data: {
                pageNum: 1,
                pageSize: pageSize,
                status: values.status,
                searchContent: values.searchContent,
            }
        }).then((res) => {
            if (res.code === 200) {
                setDataSource(res.data.list)
                setTotal(res.data.total)
            } else {
                message.error(res.message)
            }
            setTableLoading(false)
        }).catch((err) => {

        });
    }
    const onReset = () => {
        form.resetFields();
    };
    const onFinish = (values) => {
        setPage(1)
        setmyValues(values)
        getSearchData(values)
    }
    const approvepro1 = (param) => {
        Modal.confirm({
            title: "确认审核通过?",
            cancelText: "取消",
            okText: "确定",
            centered: 'center',
            onCancel: () => {

            },
            onOk: () => {
                approvepro(param)
            },
        });
    }
    const approvepro = (param) => {
        util.httpRequest({
            url: util.API + `/massage/approve?artificerId=${param.artificerId}`,
            method: 'POST',
        }).then((res) => {
            if (res.code === 200) {
                message.success(res.message)
                getData()
            } else {
                message.error(res.message)
            }
        }).catch((err) => {

        });
    }
    const handleKeyPress = (e) => {
        if (e.code === 'Enter') {
            form.submit()
        }
    }
    const columns = [
        {
            title: '姓名',
            dataIndex: 'userName',
            key: 'userName',
            align: 'center',
            fixed: 'left',
        },
        {
            title: '昵称',
            dataIndex: 'nickName',
            key: 'nickName',
            align: 'center',
        },
        {
            title: '性别',
            dataIndex: 'userSex',
            key: 'userSex',
            align: 'center',
            render: (_, obj) => {
                if (obj.userSex === 1) {
                    return '男'
                } else {
                    return '女'
                }
            }
        },
        {
            title: '年龄',
            dataIndex: 'userAge',
            key: 'userAge',
            align: 'center',
        },
        {
            title: '电话',
            dataIndex: 'userPhone',
            key: 'userPhone',
            align: 'center',
            width: 200,
        },
        {
            title: '地址',
            dataIndex: 'userAddress',
            key: 'userAddress',
            align: 'center',
            width: 200,
        },
        {
            title: '技师状态',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (_, obj) => {
                if (obj.status === 0) {
                    return '可预约'
                } else if (obj.status === 1) {
                    return '忙碌中'
                } else {
                    return '休息中'
                }
            }
        },
        {
            title: '审核状态',
            dataIndex: 'enable',
            key: 'enable',
            align: 'center',
            render: (_, obj) => {
                if (obj.enable === 0) {
                    return '待审核'
                } else if (obj.enable === 1) {
                    return '审核通过'
                }
            }
        },
        {
            title: '接单量',
            dataIndex: 'totalOrder',
            key: 'totalOrder',
            align: 'center',
        },
        {
            title: '登录账号',
            dataIndex: 'userAccount',
            key: 'userAccount',
            align: 'center',
            width: 200,
        },
        {
            title: '密码',
            dataIndex: 'password',
            key: 'password',
            align: 'center',
            width: 100,
        },
        {
            title: '从业(年)',
            dataIndex: 'workYear',
            key: 'workYear',
            align: 'center',
        },
        {
            title: '申请时间',
            dataIndex: 'applyTime',
            key: 'applyTime',
            align: 'center',
            width: 200,
        },
        {
            title: '店铺ID',
            dataIndex: 'agentId',
            key: 'agentId',
            align: 'center',
        },
        {
            title: '身份证',
            dataIndex: 'userIdCard',
            key: 'userIdCard',
            align: 'center',
            width: 200,
            render: (_, record) => (
                <Image
                    width={180}
                    height={50}
                    src={record.userIdCard}
                />
            ),
        },
        {
            title: '健康证',
            dataIndex: 'healthCertificate',
            key: 'healthCertificate',
            align: 'center',
            width: 200,
            render: (_, record) => {
                if (record.healthCertificate) {
                    return (
                        <Image
                            width={180}
                            height={50}
                            src={record.healthCertificate}
                        />
                    )
                } else {
                    return <span>未上传</span>
                }
            }
        },
        {
            title: '按摩证',
            dataIndex: 'massageCertificate',
            key: 'massageCertificate',
            align: 'center',
            width: 200,
            render: (_, record) => {
                if (record.massageCertificate) {
                    return (
                        <Image
                            width={180}
                            height={50}
                            src={record.massageCertificate}
                        />
                    )
                } else {
                    return <span>未上传</span>
                }
            }
        },
        {
            title: '操作',
            dataIndex: 'address',
            key: 'address',
            align: 'center',
            fixed: 'right',
            render: (_, obj) => {
                if (obj.enable === 0) {
                    return <UsergroupAddOutlined title='审核' onClick={() => approvepro1(obj)} style={{ color: '#cfae9f', fontSize: '1.5rem' }} />
                } else if (obj.enable === 1) {
                    return <UsergroupAddOutlined title='审核' style={{ color: '#ccc', fontSize: '1.5rem', }} />
                }
            }
        },
    ];
    return (
        <div className={styles.home}>
            <Menus select={'technician'} />
            <div className={styles.content}>
                <div className={styles.top}>
                    <Form
                        form={form}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                        autoComplete="off"
                        initialValues={{
                            status: 1,
                            searchContent: ''
                        }}
                    >
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item
                                    name="status"
                                    label="审核状态"
                                >
                                    <Select >
                                        <Option value={0}>待审核</Option>
                                        <Option value={1}>审核通过</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name="searchContent"
                                >
                                    <Input onKeyDown={handleKeyPress} placeholder='请输入地址或者姓名' />
                                </Form.Item>
                            </Col>
                            <Col span={12} style={{ textAlign: 'end' }}>
                                <Form.Item
                                    wrapperCol={{
                                        offset: 8,
                                        span: 16,
                                    }}
                                >
                                    <Space size={24}>
                                        <Button type="primary" htmlType="submit">
                                            查询
                                        </Button>
                                        <Button htmlType="button" onClick={onReset}>
                                            重置
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className={styles.table}>
                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        pagination={{
                            total: total,
                            current: page,
                            pageSize: pageSize,
                            showTotal: total => `共 ${total} 条`,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            onChange: (page, pageSize) => {
                                setPage(page)
                                setPageSize(pageSize)
                            }
                        }
                        }
                        loading={tableLoading}
                        rowKey={record => record.artificerId}
                        scroll={{
                            x: 2700,
                            y: '40rem',
                        }}
                    />
                </div>
            </div>
            <Record />
        </div>
    )
}

export default Index